import PuxaPlacaApiRepository from "../../external/puxaPlacaApi";

class PuxaPlacaService {
  consultarPlaca(placa) {
    return new PuxaPlacaApiRepository(
      `/puxa-placa/consulta/${encodeURIComponent(placa)}`,
    ).get();
  }
}

export default PuxaPlacaService;
